import React, { createContext, useState, useEffect } from "react";
import {getCropsAndVarieties,getAllMachines} from "../utils/api";

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [scans, setScans] = useState([]);
  const [crops, setCrops] = useState([]);
  const [machines, setMachines] = useState([]);
  const [selectedCrop, setSelectedCrop] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [selectedMachine, setSelectedMachine] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [pageSize, setPageSize] = useState(5);

  const setScanData = (scanData) => {
    setScans(scanData);
  };

  const setSelectedCropData = (cropData) => {
    setSelectedCrop(cropData);
  };
  const setSelectedMachineData = (cropData) => {
    setSelectedMachine(cropData);
  };
  const setSearchTermData = (term) => {
    setSearchTerm(term);
  };

  useEffect(() => {
    const fetchCrops = async () => {
      try {
        const response = await getCropsAndVarieties();
        if (response?.data?.data) {
          setCrops(response.data.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCrops();
  }, []);
  
  useEffect(() => {
    const fetchMachines = async () => {
      try {
        const response = await getAllMachines();
        if (response?.data?.data) {
          setMachines(response.data.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchMachines();
  }, []);

  return (
    <DataContext.Provider
      value={{
        scans,
        setScans,
        setScanData,
        selectedCrop,
        setSelectedCrop,
        setSelectedCropData,
        selectedMachine,
        setSelectedMachine,
        setSelectedMachineData,
        searchTerm,
        setSearchTerm,
        setSearchTermData,
        crops,
        machines,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        pageSize,
        setPageSize,
      }}
    >
      {isLoading ? <p>Loading Scans...</p> : children}
    </DataContext.Provider>
  );
};
